import * as React from "react"

const PDF = props => (
  <div>
    <>
      <a className="text-primary" href={props.href} download>
        <i className="fa-solid fa-file-pdf pr-2 text-danger" />
        {props.title}
      </a>
    </>
  </div>
)

export default PDF
